import { O as Option, d as defineCustomElement$1 } from './option.js';

const TtOption = Option;
const defineCustomElement = defineCustomElement$1;

export { TtOption, defineCustomElement };
